import React from 'react';
import Promotions from '../components/Promotions';

const PromotionsPage = () => {
  return <Promotions />;
};

export default PromotionsPage;
